/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Processing_Queue_StatusInputs */

const en_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing Event Queue...`)
};

const fr_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement de la file d'attente des evenements...`)
};

const de_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung der Ereigniswarteschlange...`)
};

const it_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione coda eventi...`)
};

const ru_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка очереди событий...`)
};

const es_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando cola de eventos...`)
};

const zh_cn2_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理事件队列...`)
};

const ja_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント キューを処理中...`)
};

const hi_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट क्यू को प्रोसेस किया जा रहा है...`)
};

const pt_pt2_render_audio_processing_queue_status = /** @type {(inputs: Render_Audio_Processing_Queue_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando fila de eventos...`)
};

/**
* | output |
* | --- |
* | "Processing Event Queue..." |
*
* @param {Render_Audio_Processing_Queue_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_processing_queue_status = /** @type {((inputs?: Render_Audio_Processing_Queue_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Processing_Queue_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_processing_queue_status(inputs)
	if (locale === "de") return de_render_audio_processing_queue_status(inputs)
	if (locale === "it") return it_render_audio_processing_queue_status(inputs)
	if (locale === "ru") return ru_render_audio_processing_queue_status(inputs)
	if (locale === "es") return es_render_audio_processing_queue_status(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_processing_queue_status(inputs)
	if (locale === "ja") return ja_render_audio_processing_queue_status(inputs)
	if (locale === "hi") return hi_render_audio_processing_queue_status(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_processing_queue_status(inputs)
	return en_render_audio_processing_queue_status(inputs)
});